import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomInputComponent } from '@/components/custom-input/custom-input.component';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { LoadingComponent } from '@/components/loading/loading.component';
import { Utils } from '@/utils/utils';
import { Component, Output, EventEmitter, ChangeDetectorRef, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-imap-form',
  imports: [
    CustomModalComponent,
    ReactiveFormsModule,
    CustomInputComponent,
    LoadingComponent,
  ],
  templateUrl: './imap-form.component.html',
  styleUrl: './imap-form.component.scss',
})
export class ImapFormComponent implements OnInit {
  @Output() closeFunction = new EventEmitter<void>();
  @Output() acceptFunction = new EventEmitter<void>();

  public loading = signal(false);
  public saving = signal(false);
  public saveForm: FormGroup = new FormGroup({});

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.loadCurrentConfig();
  }

  createForm() {
    this.saveForm = new FormGroup({
      host:           new FormControl('', [Validators.required]),
      port:           new FormControl(993, [Validators.required, Validators.min(1)]),
      username:       new FormControl('', [Validators.required, Validators.email]),
      password:       new FormControl('', [Validators.required]),
      drafts_folder:  new FormControl('Drafts', [Validators.required]),
    });
  }

  loadCurrentConfig() {
    this.loading.set(true);
    this.apiService.getPetition(Urls.urls.company).subscribe({
      next: (res: any) => {
        const imap = res.list[0]?.imap_config;
        if (imap) {
          this.saveForm.patchValue(imap);
        }
        this.loading.set(false);
        this.cdr.detectChanges();
      },
      error: () => {
        this.loading.set(false);
      }
    });
  }

  saveEntity() {
    if (this.saveForm.valid) {
      this.saving.set(true);
      this.apiService.save(Urls.urls.companyImap, this.saveForm.value, 0).subscribe({
        next: () => {
          Utils.notification.success('Configuración IMAP guardada correctamente');
          this.acceptFunction.emit();
          this.closeFormFunction();
        },
        error: (error: any) => {
          Utils.notification.alert(Utils.extractErrorMessage(error) || 'Error al guardar la configuración IMAP');
          this.saving.set(false);
        },
        complete: () => {
          this.saving.set(false);
        }
      });
    } else {
      Utils.notification.alert('Debe completar todos los campos obligatorios');
    }
  }

  acceptFormFunction() { this.saveEntity(); }
  closeFormFunction() { this.closeFunction.emit(); }
}
